import { toast } from "react-hot-toast";

// 导出 toast 实例
export default toast;
